import './overview.scss';
import React, { useEffect } from 'react';
import { Row } from 'antd';
import OverviewSection from './OveriewSection';
import SoldeCard from '../SoldeCard';
import { formatAmount } from 'app/utils/amountFormatter';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getAdminDashboard } from '../finance.reducers';
import { getEcolesComptes } from 'app/entities/ecole/ecole.reducer';
import useRandomColors from 'app/hooks/useRandomColors';
import DashBoardSkeleton from '../DashBoardSkeleton';

const AdminOverView: React.FC = () => {
  const dispatch = useAppDispatch();
  const { loading, dashboardData } = useAppSelector(state => state.finance);
  const comptes = useAppSelector(state => state.ecole.entities);

  const soldeCardsData = [
    {
      amount: dashboardData.soldeOmKoriSchool,
      name: 'Solde OM',
      title: 'Total Solde Orange Money',
      className: 'card-om',
      color: 'white',
    },
    {
      amount: dashboardData.soldeWaveKoriSchool,
      name: 'Solde Wave',
      title: 'Total Solde Wave',
      className: 'card-wave',
      color: 'white',
    },
  ];

  const fraisEncaissement = [
    {
      amount: dashboardData.soldeScolarite,
      name: 'Solde Encaissement',
      title: 'Total Encaissement',
      className: 'card-encaissement',
    },
    {
      amount: dashboardData.fraisEncaissement,
      name: 'Frais Encaissement',
      title: 'Total Frais',
      className: 'card-encaissement-light',
    },
  ];

  const fraisSalaire = [
    {
      amount: dashboardData.soldeSalaire,
      name: 'Solde Salaire',
      title: 'Total Salaire',
      className: 'card-salaire',
    },
    {
      amount: dashboardData.fraisPaiement,
      name: 'Frais Salaire',
      title: 'Total Frais',
      className: 'card-salaire-light',
    },
  ];

  const pieDataEncaissementOMWave = [
    { name: 'OM', value: dashboardData.totalEncaissementOM, currency: 'FCFA' },
    { name: 'Wave', value: dashboardData.totalEncaissementWave, currency: 'FCFA' },
  ];

  const pieDataSalaireOMWave = [
    { name: 'OM', value: dashboardData.totalPaiementOM, currency: 'FCFA' },
    { name: 'Wave', value: dashboardData.totalPaiementWave, currency: 'FCFA' },
  ];

  const pieDataEncaissementEcoles = comptes.map(c => ({ name: c.nom, value: c.compte?.solde, currency: 'FCFA' }));
  const pieDataSalaireEcoles = comptes.map(c => ({ name: c.nom, value: c.compteSalaire?.solde, currency: 'FCFA' }));

  const colorsOMWave = ['#f16e00', '#1AB3E5'];
  const colorsEcoles = {
    encaissement: useRandomColors({ comptes }).randomBackgroundColor,
    salaire: useRandomColors({ comptes, shuffle: 4 }).randomBackgroundColor,
  };

  useEffect(() => {
    dispatch(getAdminDashboard());
    dispatch(getEcolesComptes());
  }, []);

  return (
    <div style={{ padding: 24 }}>
      {loading || !dashboardData ? (
        <DashBoardSkeleton />
      ) : (
        <>
          <Row gutter={[16, 16]}>
            {soldeCardsData.map((card, index) => (
              <SoldeCard
                lg
                key={`${card.name}-${index}`}
                amount={formatAmount(card.amount)}
                name={card.name}
                title={card.title}
                className={card.className}
              />
            ))}

            {fraisEncaissement.map((card, index) => (
              <SoldeCard lg key={index} amount={formatAmount(card.amount)} name={card.name} title={card.title} className={card.className} />
            ))}
            {fraisSalaire.map((card, index) => (
              <SoldeCard lg key={index} amount={formatAmount(card.amount)} name={card.name} title={card.title} className={card.className} />
            ))}
          </Row>
          <OverviewSection
            sectionTitle="Encaissement"
            fraisData={fraisEncaissement}
            pieChartDataOMWave={pieDataEncaissementOMWave}
            pieChartDataEcoles={pieDataEncaissementEcoles}
            pieColorsOMWave={colorsOMWave}
            pieColorsEcoles={colorsEcoles.encaissement}
          />
          <OverviewSection
            sectionTitle="Salaire"
            fraisData={fraisSalaire}
            pieChartDataOMWave={pieDataSalaireOMWave}
            pieChartDataEcoles={pieDataSalaireEcoles}
            pieColorsOMWave={colorsOMWave}
            pieColorsEcoles={colorsEcoles.salaire}
          />
        </>
      )}
    </div>
  );
};

export default AdminOverView;
